"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateUUID = exports.addRequiredCountValidation = exports.addRequiredValidation = exports.isValidUrl = void 0;
const HTTP_REGEX = /^[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b(?:[-a-zA-Z0-9()@:%_\+.~#?&//=]*)$/;
function isValidUrl(url) {
    return HTTP_REGEX.test(url);
}
exports.isValidUrl = isValidUrl;
const addRequiredValidation = (message = "This question is required") => ({
    type: "required",
    message,
});
exports.addRequiredValidation = addRequiredValidation;
const addRequiredCountValidation = ({ min, max, }) => {
    const validation = {
        type: "require_count",
        // this isn't actually being used currently, validation message will be generated on STS
        message: "This field is required",
    };
    if (typeof min === "number" && min > 0) {
        validation.min = min;
    }
    if (typeof max === "number" && max > 0) {
        validation.max = max;
    }
    return validation;
};
exports.addRequiredCountValidation = addRequiredCountValidation;
/**
 * Generate a UUID portably.  Slightly tweaked from the credited
 * implementation.
 *
 * Author: Abhishek Dutta, 12 June 2020
 * License: CC0 (https://creativecommons.org/choose/zero/)
 */
function generateUUID() {
    const temp_url = URL.createObjectURL(new Blob([]));
    // originally returned of the form blob:identifier/{uuid} but in node can be blob:identifier:{uuid}
    // this handles both cases
    const uuid = temp_url.toString().split(/[:\/]/g).pop();
    URL.revokeObjectURL(temp_url);
    if (!uuid) {
        throw new Error("unable to create UUID");
    }
    return uuid;
}
exports.generateUUID = generateUUID;
//# sourceMappingURL=util.js.map